import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import FlowActionMenu from "./components/FlowActionMenu/FlowActionMenu";
import {
  getDraftSkillsById,
  setDraft,
  setSkillId,
} from "../../../../../redux/actions/skill";

import DataMapperModal from "./components/FlowActionMenu/DataMapperModal";
import PlayModalWebAuto from "./components/FlowActionMenu/PlayModalWebAuto";
import BottomBar from "./components/BottomBar";
import Flow from "./components/FlowDiagram";
import Loader from "../../../../../components/loader";
import TemplateInstructions from "../../../../../components/templateInstructions";
import PlaceHolder from "./components/PlaceHolderLoading";
import { notify } from "../../../../../redux/actions/snack";
import $ from "jquery";
import { Helmet } from "react-helmet";
import ProcessDiscoverySideBar from "../ProcessDiscovery/ProcessDiscoverySideBar";

const FlowScreen = () => {
  const isMounted = useRef(0);
  const dispatch = useDispatch();
  const params = useParams();

  const skill = useSelector((state) => state?.skillReducer?.trainDraft);
  const loading = useSelector((state) => state?.skillReducer?.loading);
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrganization
  );

  useEffect(() => {
    dispatch(setSkillId(params.id));
    dispatch(getDraftSkillsById(params.id));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSkillId(null));
      dispatch(setDraft(null));
    };
  }, []);

  useEffect(() => {
    document.addEventListener("execution-started", sendNotification);
    document.addEventListener("execution-errored", sendNotification);
    return () => {
      document.removeEventListener("execution-started", sendNotification);
      document.removeEventListener("execution-errored", sendNotification);
    };
  }, []);

  useEffect(() => {
    if (skill) {
      checkAdminViewAccess(skill);
    }
    return () => {
      $(".sidebar-global").show();
      $(".process-sidebar").hide();
    };
  }, [skill?.id]);

  const checkAdminViewAccess = (s) => {
    if (s?.TEMPLATE == "Process Discovery") {
      $(".sidebar-global").hide();
      $(".process-sidebar").show();
    } else {
      $(".sidebar-global").show();
      $(".process-sidebar").hide();
    }
  };

  const sendNotification = (msg) => {
    if (msg.detail.result) {
      dispatch(notify("success", `Agent triggered successfully.`));
    }
    if (msg.detail.cause) {
      if (msg.detail.cause.error === "Feature automations exhausted") {
        dispatch(
          notify(
            "error",
            "Agent execution limit exceeded. Please renew/upgrade your plan"
          )
        );
      } else {
        dispatch(notify("error", `${msg.detail.cause}`));
      }
    }
  };

  return (
    <React.Fragment>
      <ProcessDiscoverySideBar />
      {!skill && loading ? (
        <PlaceHolder />
      ) : (
        <>
          {skill ? (
            <div className="fw-screen">
              <DataMapperModal />
              <PlayModalWebAuto />
              <div className="chat-col-skill">
                <FlowActionMenu />
                <Flow></Flow>

                {skill?.TEMPLATE === "Process Discovery" ? null : (
                  <>
                    <TemplateInstructions state={skill?.TEMPLATE} />
                    <BottomBar />
                  </>
                )}
              </div>
            </div>
          ) : null}
        </>
      )}
      <Helmet>
        <script
          async
          type="module"
          src={`https://${process.env.REACT_APP_PUBLIC_BUCKET}/$web/supervity-chat-widget.js`}
        />
        {/* <script async type="module" src={`${process.env.PUBLIC_URL}/scw.js`} /> */}
      </Helmet>
    </React.Fragment>
  );
};

export default FlowScreen;
